/**
 * Выбор картинки промо-попапа: тема + viewport.
 * Мобилка: если есть mobile-ассет — берём его, иначе desktop (адаптируется).
 */

export type PromoModalImageSet = {
  offerLight: string | null;
  offerDark: string | null;
  offerLightMobile: string | null;
  offerDarkMobile: string | null;
  successLight: string | null;
  successDark: string | null;
  successLightMobile: string | null;
  successDarkMobile: string | null;
};

function firstNonEmpty(...values: Array<string | null | undefined>): string | null {
  for (const v of values) {
    const t = typeof v === "string" ? v.trim() : "";
    if (t) return t;
  }
  return null;
}

/** Есть ли хоть одна картинка оффера (иначе попап не показываем). */
export function hasPromoOfferImages(images: PromoModalImageSet): boolean {
  return Boolean(
    firstNonEmpty(
      images.offerLight,
      images.offerDark,
      images.offerLightMobile,
      images.offerDarkMobile,
    ),
  );
}

export function hasPromoSuccessImages(images: PromoModalImageSet): boolean {
  return Boolean(
    firstNonEmpty(
      images.successLight,
      images.successDark,
      images.successLightMobile,
      images.successDarkMobile,
    ),
  );
}

/**
 * Выбрать URL для текущего viewport/темы.
 * Desktop: только desktop-поля (+ fallback по теме).
 * Mobile: mobile → иначе desktop.
 */
export function pickPromoModalImage(
  images: PromoModalImageSet,
  kind: "offer" | "success",
  opts: { isDark: boolean; isMobile: boolean },
): string | null {
  const lightDesktop =
    kind === "offer" ? images.offerLight : images.successLight;
  const darkDesktop = kind === "offer" ? images.offerDark : images.successDark;
  const lightMobile =
    kind === "offer" ? images.offerLightMobile : images.successLightMobile;
  const darkMobile =
    kind === "offer" ? images.offerDarkMobile : images.successDarkMobile;

  const light = opts.isMobile
    ? firstNonEmpty(lightMobile, lightDesktop)
    : firstNonEmpty(lightDesktop);
  const dark = opts.isMobile
    ? firstNonEmpty(darkMobile, darkDesktop)
    : firstNonEmpty(darkDesktop);

  if (opts.isDark) return firstNonEmpty(dark, light);
  return firstNonEmpty(light, dark);
}

export const PROMO_MOBILE_MEDIA_QUERY = "(max-width: 767px)";
